export default {
  BusinessPurchaseOrderDetail: {
    status: '采购单状态',
    operationLog: '操作日志',
    storageStatus: '入库状态',
    planQty: '采购数量',
    alreadyQty: '已入库',
    waitQty: '未入库',
    cancelQty: '停止等待',
    poInformation: '采购单基本信息',
    code: '采购单号',
    typeMeaning: '采购类型',
    supplierName: '供应商',
    warehouseName: '收货仓',
    auditTime: '审核时间',
    finishTime: '完成时间',
    buyerName: '采购员',
    paymentType: '结算方式',
    invoiceTypeMeaning: '发票类型',
    packagingFlag: '是否含包装',
    shippingFlag: '是否包邮',
    overfillRate: '溢装比例',
    expectedDate: '预计到货时间',
    remark: '备注',
    logisticsBusinessName: '物流公司',
    logisticsNo: '物流单号',
    logisticsAmount: '运费',
    recipientName: '收货人',
    phone: '手机',
    shippingAddress: '收货地址',
    sourceCode: '来源单号',
    thirdCode: '外部单号',
    productInformation: '商品信息',
    notice: '通知',
    result: '结果',
    purchaseOrder: '采购单',
    log: '日志',

    table: {
      spuPic: '商品图片',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQty: '采购数量',
      alreadyQty: '入库数量',
      waitQty: '未入库数量',
      cancelQty: '停止等待数量',
      taxUnitPrice: '含税下单价',
      taxRate: '税率',
      taxPrice: '含税金额',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码',
      remark: '商品备注',
      meaning: '关联单据',
      typeMeaning: '关联单据类型',
      associatedCode: '关联单号',
      associatedStatusMeaning: '单据状态',
    }
  }
};
